// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"d862ca7e","488":"de869c2b"}[chunkId] + ".chunk.js";
};